<section class="benin-rj" [style.background-image]="'url(' + backgroundImage + ')'">
  <div class="benin-rj__overlay"></div>

  <div class="benin-rj__inner">
    <div class="benin-rj__plaque">
      <img [src]="plaqueImage" alt="RJ International Benin City" />
    </div>

    <p class="benin-rj__intro">
      Our first development in this mission, the RJ International (Benin City)
    </p>

    <h2>A CAUSE FOR RJ INTERNATIONAL</h2>

    <div class="benin-rj__mission">
      <p>RJ BRAND Mission:</p>
      <p>To Reveal the Royalty of AFRICANS</p>
    </div>

    <p class="benin-rj__cause-note">
      We have set the Cause for RJ INTERNATIONAL that will be Unique.
    </p>

    <ul class="benin-rj__highlights">
      @for (highlight of highlights; track highlight) {
        <li>{{ highlight }}</li>
      }
    </ul>

    <div class="benin-rj__meta">
      <p>Developer: ZUMERA PROPERTY DEVELOPMENT LTD</p>
      <p>PROJECT NAME: ZUMERA EWEKA (BENIN CITY)</p>
      <p>PROJECT DESCRIPTION:</p>
    </div>

    <div class="benin-rj__description">
      <p>
        Our flagship project, Eweka, is named after the first Oba (King) of the Benin Kingdom. He established the Obaship of the kingdom, an institution that has endured to this day.
      </p>
      <p>
        His philosophy was simple: royalty exists in everyone. Therefore, to govern royalty, you must first be one yourself. You must speak their language, understand them, and build for them from within their own culture. Only then can you truly reign.
      </p>
      <p>Hence, ZUMERA EWEKA means:</p>
      <p>&ldquo;The Soul of the King.&rdquo;</p>
      <p>
        It will be a development created as an Elegant Hospitality and Entertainment Destination for discerning guests to play and relax.
      </p>
      <p>
        ZUMERA EWEKA (Benin City): An Ultra-Luxury Boutique Hotel, will be designed to appeal to and attract those who do not currently visit Benin City, as well as everyone who already does. It is meant to be a place of class in a very real sense. A true picture of this seven-century-old city&rsquo;s identity and heritage, which has always been Power, Freedom, and Beauty. The freedom to become whoever you want to be, however you want to be it, and whenever you choose to be it. That is true Royalty.
      </p>
      <p>
        A Symbol of Greatness. The loveliest, most elegant, and most beautiful hotel ever built in history. Think: &quot;Everything beautiful.&quot;
      </p>
      <p>Ultra-Luxury. Class. Hospitality. An unforgettable experience.</p>
    </div>

    <p class="benin-rj__relaunching">RELAUNCHING SOON!</p>

    <p class="benin-rj__signature">The Signature of Class</p>
  </div>
</section>
